import axiosInstance from '../axiosInterceptor/axiosInstance'

// `documentHash` pins the contract the signer was shown; only a kick-off invitation of an org that
// still owes a signature needs it. Error reporting is left to the caller so a stale-contract
// rejection can be recovered in place. Resolves to { accessToken }.
const invitationAccept = ({ orgId, invitationId, documentHash = null }) =>
  axiosInstance
    .post(
      `v1/orgs/${orgId}/invitations/${invitationId}/accept`,
      { documentHash },
      { skipErrorNotification: Boolean(documentHash) },
    )
    .then((r) => r.data)

export default invitationAccept
